import { render, staticRenderFns } from "./Serials.vue?vue&type=template&id=d545d334&scoped=true"
import script from "./Serials.vue?vue&type=script&lang=js"
export * from "./Serials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d545d334",
  null
  
)

export default component.exports